import { apiClient } from "./client";

export type ChecklistStepKey =
  | "tenant_branded"
  | "organization_created"
  | "slot_template_created"
  | "practitioner_added"
  | "membership_active"
  | "users_invited"
  | "shift_pattern_created"
  | "planning_published";

export type ChecklistStep = {
  key: ChecklistStepKey;
  done: boolean;
  count: number;
};

export type ChecklistOut = {
  tenant_id: string;
  completed: number;
  total: number;
  steps: ChecklistStep[];
};

export async function getOnboardingChecklist(): Promise<ChecklistOut> {
  const { data } = await apiClient.get<ChecklistOut>("/api/v1/me/onboarding/checklist");
  return data;
}
